import Button from "@/common/ui/Button";
import { LightText2 } from "@/common/ui/Text";
import React, { useState } from "react";

interface ConfirmationModalProps {
  onClose: (props?: any) => void;
  handleCancel: () => void;
  handleConfirm: () => void;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({ handleCancel, handleConfirm }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirmClick = async () => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 10000);
    handleConfirm();
  };

  return (
    <div className="pb-4 pt-2 px-4">
      <LightText2 text="Are you sure you want to remove the profile picture?" className=" max-w-[220px]" />
      <div className={`flex justify-end gap-4 w-full pt-4`}>
        {handleCancel && (
          <Button variant="secondary" size="small" onClick={handleCancel}>
            Cancel
          </Button>
        )}
        <Button variant="primary" size="small" onClick={handleConfirmClick} isLoading={isLoading} className=" !bg-text-red">
          Confirm
        </Button>
      </div>
    </div>
  );
};

export default ConfirmationModal;
